<template>
  <v-layout>
    <v-col v-if="Role.isForm" cols :sm="12" class="pa-0">
      <v-form v-model="Role.isValid" ref="form">
        <v-card flat class="pt-5">
          <v-layout align-center class="px-3">
            <h2>{{ $t("menu.role") }}</h2>
            <v-spacer></v-spacer>
            <v-icon @click="_fnReset()" color="primary"> mdi-close </v-icon>
          </v-layout>
          <v-card-text>
            <v-row>
              <v-col cols :sm="12" class="py-0">
                <v-text-field
                  color="primary"
                  v-model="Role.obj.name"
                  :rules="[Rules.required]"
                >
                  <template #label>
                    {{ $t(`table.name`) }}
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="12" class="py-0">
                <v-row v-for="mission in roles" :key="mission.id">
                  <v-col cols class="py-2 body-1" :sm="3">
                    {{ mission.name }}
                  </v-col>
                  <v-col cols class="mt-1" :sm="9">
                    <v-row v-if="mission.privileges.length">
                      <v-col
                        cols
                        class="py-0"
                        :sm="3"
                        v-for="privileges in mission.privileges"
                        :key="`${mission.id}-${privileges.id}`"
                      >
                        <v-checkbox
                          color="primary"
                          :label="privileges.name"
                          hide-details
                          v-model="Role.obj.selected"
                          :value="`${mission.id}-${privileges.id}`"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col class="px-3 py-0" :sm="12">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="px-4 mt-5">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="!Role.isValid || !Role.obj.selected.length"
              @click="Role.isCreate ? _fnCreate() : _fnUpdate()"
            >
              {{ Role.isCreate ? $t(`table.create`) : $t(`table.update`) }}
            </v-btn>
            <v-btn outlined color="primary" @click="_fnReset()">
              {{ $t(`table.cancel`) }}
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>

    <v-dialog
      v-if="Role.isDelete"
      v-model="Role.isDelete"
      persistent
      scrollable
      max-width="500"
    >
      <v-card>
        <v-card-title dense class="headline primary" />
        <v-card-text class="pt-2">
          {{ $t(`table.deleteMess`) }}
          <b>{{ Role.obj.name }}</b>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="_fnDelete()">
            {{ $t(`table.delete`) }}
          </v-btn>
          <v-btn outlined color="primary" @click="_fnReset()">
            {{ $t(`table.cancel`) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  data: () => ({
    model: "Role",
    roles: [],
  }),
  created() {
    this.roles = this.Constant.obj["MISSION"].map((mission) => ({
      ...mission,
      privileges: mission.privileges.map((privilege) =>
        this.Constant.obj["PRIVILEGE"].find((p) => p.id === privilege)
      ),
    }));
  },
  methods: {
    _fnReset() {
      if (this.$refs.form) this.$refs.form.reset();
      this.fnResetFlagView(this.model);
    },
    _fnReFresh() {
      this._fnReset();
      this[this.model].isRefresh = true;
    },
    _fnConvert() {
      const missionList = this[this.model].obj.selected.map((select) => {
        const value = select.split("-");
        return { [value[0]]: value[1] };
      });
      const missionObject = this._.groupBy(missionList, Object.keys);
      const data = [];
      this._.forEach(missionObject, (value, key) => {
        data.push({ mission: key, privileges: value.map((v) => v[key]) });
      });
      this[this.model].obj.missions = data;
    },
    async _fnCreate() {
      this._fnConvert();
      const { code } = await this.fnPost({
        url: `/v1/admin/role`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
    async _fnUpdate() {
      this._fnConvert();
      const { code } = await this.fnPut({
        url: `/v1/admin/role/${this[this.model].obj.id}`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
    async _fnDelete() {
      const { code } = await this.fnDelete({
        url: `/v1/admin/role/${this[this.model].obj.id}`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
  },
};
</script>
